import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { 
  HelpCircle, ChevronDown, Search, MessageCircle,
  Zap, Shield, Bell, CreditCard, User, Settings,
  TrendingUp, Target, Clock, ArrowRight
} from 'lucide-react';
import SEO, { FAQStructuredData } from '../components/SEO';

const SSSPage = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [activeCategory, setActiveCategory] = useState('all');
  const [openQuestions, setOpenQuestions] = useState({});

  const categories = [
    { id: 'all', label: 'Tümü', icon: HelpCircle },
    { id: 'genel', label: 'Genel', icon: Zap },
    { id: 'sinyal', label: 'Sinyaller', icon: TrendingUp },
    { id: 'uyelik', label: 'Üyelik & Ödeme', icon: CreditCard },
    { id: 'bildirim', label: 'Bildirimler', icon: Bell },
    { id: 'guvenlik', label: 'Güvenlik', icon: Shield },
  ];

  const faqs = [
    // Genel
    {
      id: 1,
      category: 'genel',
      question: 'Borsamex nedir?',
      answer: 'Borsamex, yapay zeka destekli bir trading sinyal platformudur. AI algoritmalarımız 7/24 piyasaları analiz eder ve AL/SAT/BEKLE sinyalleri üretir. Siz sadece sinyalleri takip eder ve kendi kararınızı verirsiniz.'
    },
    {
      id: 2,
      category: 'genel',
      question: 'Borsamex nasıl çalışır?',
      answer: 'Yapay zeka algoritmalarımız teknik göstergeleri (RSI, MACD, Bollinger vb.) ve fiyat hareketlerini analiz eder. Fırsat tespit edildiğinde giriş fiyatı, hedef seviyeler (TP1, TP2, TP3) ve stop-loss içeren bir sinyal oluşturulur. Sinyal size bildirim olarak ulaşır.'
    },
    {
      id: 3,
      category: 'genel',
      question: 'Borsama bağlanıyor musunuz? API key istiyor musunuz?',
      answer: 'Hayır, kesinlikle hayır! Borsamex sadece sinyal verir. Borsanıza bağlanmıyoruz, API key istemiyoruz, paranıza dokunmuyoruz. İşlemi kendi hesabınızda kendiniz yaparsınız. Tam kontrol sizde.'
    },
    {
      id: 4,
      category: 'genel',
      question: 'Hangi piyasalar için sinyal veriyorsunuz?',
      answer: 'Şu anda kripto para piyasası için BTC, ETH, SOL ve diğer major coinler için sinyal üretiyoruz. İleride forex ve borsa için de sinyal eklemeyi planlıyoruz.'
    },
    // Sinyal
    {
      id: 5,
      category: 'sinyal',
      question: 'Sinyal ne demek?',
      answer: 'Sinyal, bir varlığın alınması veya satılması için yapılan öneridir. Her sinyalde şunlar bulunur: Yön (AL/SAT), Giriş fiyatı, Hedef fiyatlar (TP1, TP2, TP3), Stop-loss seviyesi. Bu bilgilerle risk yönetimi yaparak işlem açabilirsiniz.'
    },
    {
      id: 6,
      category: 'sinyal',
      question: 'TP1, TP2, TP3 ne anlama geliyor?',
      answer: 'TP = Take Profit (Kar Al). TP1 ilk hedef, TP2 ikinci hedef, TP3 ise en iddialı hedeftir. Sinyalin TP1\'e ulaşma olasılığı en yüksek, TP3\'e ulaşma olasılığı en düşüktür. Risk iştahınıza göre hangi hedefte kar alacağınıza siz karar verirsiniz.'
    },
    {
      id: 7,
      category: 'sinyal',
      question: 'Stop-loss nedir ve neden önemli?',
      answer: 'Stop-loss, zararı sınırlamak için belirlenen fiyat seviyesidir. Fiyat bu seviyeye düşerse pozisyonunuzu kapatmanız önerilir. Risk yönetiminin en önemli parçasıdır - asla stop-loss olmadan işlem açmayın!'
    },
    {
      id: 8,
      category: 'sinyal',
      question: 'Her sinyal kazandırır mı?',
      answer: 'Hayır, hiçbir sistem %100 doğru sinyal veremez. Trading\'de kayıp normaldir. Önemli olan uzun vadede kazançlı olmaktır. Bu nedenle risk yönetimi kritiktir - her işleme sermayenizin küçük bir kısmıyla girin ve stop-loss kullanın.'
    },
    {
      id: 9,
      category: 'sinyal',
      question: 'Sinyalleri nereden görebilirim?',
      answer: 'Giriş yaptıktan sonra "Sinyaller" sayfasından tüm aktif ve geçmiş sinyalleri görebilirsiniz. Pro üyeler ayrıca Telegram, Push ve E-posta bildirimleri alır.'
    },
    // Üyelik & Ödeme
    {
      id: 10,
      category: 'uyelik',
      question: 'Ücretsiz plan ile ne yapabilirim?',
      answer: 'Ücretsiz plan ile: Tüm canlı sinyalleri görebilir, hedef seviyeleri (TP1, TP2, TP3) takip edebilir, pozisyon durumunu izleyebilir ve geçmiş performansı inceleyebilirsiniz. Anlık bildirimler Pro üyelik gerektirir.'
    },
    {
      id: 11,
      category: 'uyelik',
      question: 'Pro üyeliğin farkı nedir?',
      answer: 'Pro üyelik ile anlık bildirimler alırsınız: Telegram, Push ve E-posta. Sinyal geldiğinde anında haberdar olursunuz - sinyali geç görürseniz fırsat kaçar. Ayrıca öncelikli destek ve gelecek premium özelliklere erken erişim sağlarsınız.'
    },
    {
      id: 12,
      category: 'uyelik',
      question: 'Pro üyelik ücreti ne kadar?',
      answer: 'Aylık: 590 TL, 3 Aylık: 1.490 TL (ayda 497 TL - 1 ay bedava), Yıllık: 4.990 TL (ayda 416 TL - 3+ ay bedava). Kurucu Üye olarak fiyatınız ömür boyu sabit kalır!'
    },
    {
      id: 13,
      category: 'uyelik',
      question: 'Ödeme yöntemleri nelerdir?',
      answer: 'Kredi kartı ve banka kartı ile ödeme yapabilirsiniz. Ödemeler güvenli altyapı üzerinden işlenir. Yakında havale/EFT seçeneği de eklenecektir.'
    },
    {
      id: 14,
      category: 'uyelik',
      question: 'İptal ve iade politikası nedir?',
      answer: 'Üyeliğinizi istediğiniz zaman iptal edebilirsiniz. İptal sonrası mevcut dönem sonuna kadar Pro özelliklerini kullanmaya devam edersiniz. İade için ilk 7 gün içinde destek ekibimizle iletişime geçin.'
    },
    // Bildirimler
    {
      id: 15,
      category: 'bildirim',
      question: 'Telegram bildirimleri nasıl aktif edilir?',
      answer: 'Ayarlar > Bildirimler > Telegram bölümünden @BorsamexSignalBot\'u başlatın ve size verilen 6 haneli kodu bota gönderin. Doğrulama sonrası Telegram bildirimleri aktif olacaktır.'
    },
    {
      id: 16,
      category: 'bildirim',
      question: 'Push bildirimleri neden gelmiyor?',
      answer: 'Push bildirimleri için: 1) Pro üyeliğiniz olmalı, 2) Tarayıcı bildirim izni vermiş olmalısınız, 3) Ayarlar\'dan push bildirimleri aktif etmiş olmalısınız. Tarayıcı ayarlarından borsamex.com için bildirim iznini kontrol edin.'
    },
    {
      id: 17,
      category: 'bildirim',
      question: 'E-posta bildirimleri nasıl açılır?',
      answer: 'Ayarlar > Bildirimler > E-posta bölümünden e-posta bildirimlerini aktif edebilirsiniz. E-postalarınız spam klasörüne düşebilir, "spam değil" olarak işaretlemeyi unutmayın.'
    },
    // Güvenlik
    {
      id: 18,
      category: 'guvenlik',
      question: 'Hesabım güvende mi?',
      answer: 'Evet. Şifreler güvenli şekilde şifrelenir (hash), HTTPS bağlantısı kullanılır ve verileriniz güvenli sunucularda saklanır. Borsanıza bağlanmadığımız için finansal riskiniz yoktur.'
    },
    {
      id: 19,
      category: 'guvenlik',
      question: 'Şifremi unuttum, ne yapmalıyım?',
      answer: 'Giriş sayfasındaki "Şifremi Unuttum" bağlantısına tıklayın ve e-posta adresinizi girin. Şifre sıfırlama linki e-postanıza gönderilecektir.'
    },
    {
      id: 20,
      category: 'guvenlik',
      question: 'Kişisel verilerim nasıl kullanılıyor?',
      answer: 'Kişisel verileriniz sadece hizmet sunumu için kullanılır. Üçüncü taraflarla paylaşılmaz veya satılmaz. Detaylar için Gizlilik Politikası sayfamızı inceleyebilirsiniz.'
    },
  ];

  const toggleQuestion = (id) => {
    setOpenQuestions(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const filteredFaqs = faqs.filter(faq => {
    const matchesCategory = activeCategory === 'all' || faq.category === activeCategory;
    const matchesSearch = searchQuery === '' || 
      faq.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
      faq.answer.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <>
      <SEO
        title="Sıkça Sorulan Sorular (SSS) | Borsamex"
        description="Borsamex hakkında merak ettikleriniz. AI trading sinyalleri, üyelik planları, bildirimler ve daha fazlası hakkında yanıtlar."
        keywords="borsamex sss, sıkça sorulan sorular, trading sinyal yardım, kripto sinyal destek, borsamex nasıl çalışır"
        url="/sss"
        structuredData={FAQStructuredData}
      />

      <div className="min-h-screen bg-brand-dark">
        {/* Hero */}
        <section className="py-16 px-6 relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-primary/5 via-transparent to-transparent" />
          <div className="absolute top-1/4 right-1/4 w-64 h-64 bg-primary/10 rounded-full blur-3xl" />
          
          <div className="container mx-auto max-w-4xl relative">
            <motion.div 
              className="text-center"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
            >
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 border border-primary/20 rounded-full mb-6">
                <HelpCircle className="h-4 w-4 text-primary" />
                <span className="text-sm text-primary font-medium">Yardım Merkezi</span>
              </div>
              
              <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
                Sıkça Sorulan Sorular
              </h1>
              <p className="text-slate-400 max-w-xl mx-auto mb-8">
                Borsamex hakkında merak ettiklerinizin yanıtlarını burada bulabilirsiniz.
              </p>

              {/* Search */}
              <div className="relative max-w-md mx-auto">
                <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" />
                <input
                  type="text"
                  placeholder="Soru ara..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full pl-12 pr-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-slate-500 focus:outline-none focus:border-primary/50 transition-colors"
                />
              </div>
            </motion.div>
          </div>
        </section>

        {/* Categories */}
        <section className="px-6 pb-8">
          <div className="container mx-auto max-w-4xl">
            <div className="flex flex-wrap justify-center gap-2">
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => setActiveCategory(cat.id)}
                  className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                    activeCategory === cat.id
                      ? 'bg-primary text-brand-dark'
                      : 'bg-white/5 text-slate-300 hover:bg-white/10'
                  }`}
                >
                  <cat.icon className="h-4 w-4" />
                  {cat.label}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ List */}
        <section className="px-6 pb-16">
          <div className="container mx-auto max-w-3xl">
            {filteredFaqs.length === 0 ? (
              <div className="text-center py-12">
                <HelpCircle className="h-12 w-12 text-slate-600 mx-auto mb-4" />
                <p className="text-slate-400">Aramanızla eşleşen soru bulunamadı.</p>
              </div>
            ) : (
              <div className="space-y-3">
                {filteredFaqs.map((faq, index) => (
                  <motion.div
                    key={faq.id}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.05 }}
                    className="bg-white/[0.02] border border-white/5 rounded-xl overflow-hidden hover:border-white/10 transition-colors"
                  >
                    <button
                      onClick={() => toggleQuestion(faq.id)}
                      className="w-full flex items-center justify-between p-5 text-left"
                    >
                      <span className="text-white font-medium pr-4">{faq.question}</span>
                      <ChevronDown 
                        className={`h-5 w-5 text-slate-400 flex-shrink-0 transition-transform ${
                          openQuestions[faq.id] ? 'rotate-180' : ''
                        }`}
                      />
                    </button>
                    <AnimatePresence>
                      {openQuestions[faq.id] && (
                        <motion.div
                          initial={{ height: 0, opacity: 0 }}
                          animate={{ height: 'auto', opacity: 1 }}
                          exit={{ height: 0, opacity: 0 }}
                          transition={{ duration: 0.2 }}
                        >
                          <div className="px-5 pb-5 text-slate-400 text-sm leading-relaxed border-t border-white/5 pt-4">
                            {faq.answer}
                          </div>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </motion.div>
                ))}
              </div>
            )}
          </div>
        </section>

        {/* Still Have Questions */}
        <section className="px-6 pb-16">
          <div className="container mx-auto max-w-3xl">
            <div className="bg-gradient-to-br from-primary/10 to-transparent border border-primary/20 rounded-2xl p-8 text-center">
              <MessageCircle className="h-10 w-10 text-primary mx-auto mb-4" />
              <h2 className="text-xl font-bold text-white mb-2">
                Sorunuz hâlâ yanıtsız mı?
              </h2>
              <p className="text-slate-400 mb-6 max-w-md mx-auto">
                İletişim formundan bize ulaşın, en kısa sürede yanıtlayalım.
              </p>
              <Link
                to="/kurumsal/iletisim"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary text-brand-dark font-semibold rounded-xl hover:bg-primary/90 transition-colors"
              >
                İletişime Geç
                <ArrowRight className="h-5 w-5" />
              </Link>
            </div>
          </div>
        </section>

        {/* Quick Links */}
        <section className="px-6 pb-16 border-t border-white/5 pt-12">
          <div className="container mx-auto max-w-4xl">
            <h3 className="text-lg font-semibold text-white text-center mb-8">Faydalı Bağlantılar</h3>
            <div className="grid md:grid-cols-3 gap-4">
              <Link 
                to="/nasil-calisir"
                className="flex items-center gap-3 p-4 bg-white/[0.02] border border-white/5 rounded-xl hover:border-primary/30 transition-colors group"
              >
                <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Target className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <div className="text-white font-medium group-hover:text-primary transition-colors">Nasıl Çalışır?</div>
                  <div className="text-xs text-slate-500">Adım adım rehber</div>
                </div>
              </Link>
              <Link 
                to="/pricing"
                className="flex items-center gap-3 p-4 bg-white/[0.02] border border-white/5 rounded-xl hover:border-primary/30 transition-colors group"
              >
                <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                  <CreditCard className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <div className="text-white font-medium group-hover:text-primary transition-colors">Fiyatlandırma</div>
                  <div className="text-xs text-slate-500">Planları karşılaştır</div>
                </div>
              </Link>
              <Link 
                to="/kurumsal/hakkimizda"
                className="flex items-center gap-3 p-4 bg-white/[0.02] border border-white/5 rounded-xl hover:border-primary/30 transition-colors group"
              >
                <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                  <User className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <div className="text-white font-medium group-hover:text-primary transition-colors">Hakkımızda</div>
                  <div className="text-xs text-slate-500">Bizi tanıyın</div>
                </div>
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SSSPage;
